// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-03T07:20:32.790Z",
  gitInfo: {
    dirty: false,
    raw: "69214af53",
    hash: "69214af53",
    distance: null,
    tag: null,
    semver: null,
    suffix: "69214af53",
    semverString: null
  }
};
/* tslint:enable */
